import { Location, SearchNormal1 } from 'iconsax-react'
import React, { useState ,useEffect} from 'react'
import { iconList } from '../../share/components/iconSVG'
import SvgIcon from '../../share/components/iconSVG'

import './Assets/styles.css'

function TourHeaderSearch({ findTours, setPlace, place, error,loading}) {

    const [dropdownDestinyTour, setDropdownDestinyTour] = useState(false)
  


    return (
        <div className='tourHeaderSearch'>
            <div className='tourHeaderSearch_'>
                <div className='tourHeaderSearch_title'>
                    <div className='tourHeaderSearch_tourIcon'>
                        <SvgIcon name={iconList.IconBag} color={'#004274'} size={50} />
                    </div>
                    <p>Tours</p>
                </div>

                <div className='tourHeaderSearch_content'>

                    <div className='tourHeaderSearch_button'>
                        <div className='tourHeaderSearch_button_'>
                            <div onClick={() => { setDropdownDestinyTour(!dropdownDestinyTour) }} className='tourHeaderSearch_buttonContent'>
                                <p className='tourHeaderSearch_buttonDestination'>Destino</p>
                                <p className='tourHeaderSearch_buttonSelect'>
                                    {
                                        place === '' ?
                                            'Elige tu Destino'
                                            :
                                            place

                                    }
                                </p>
                            </div>
                            <div className={dropdownDestinyTour === true ? 'Dropdown-tours-destino' : 'display-none'}>
                                <input type="text" placeholder='Destino' onChange={e => { setPlace(e.target.value) }} />
                                {
                                    dropdownDestinyTour === true ?
                                        <>
                                            {
                                                place !== "" &&
                                                <div className='auto-complete-tours' onClick={() => {
                                                    setPlace(place)
                                                    setDropdownDestinyTour(false)
                                                }}>
                                                    <p>{place}</p>
                                                </div>
                                            }
                                            <div className='auto-complete-tours' onClick={() => {
                                                setPlace('colombia')
                                                setDropdownDestinyTour(false)
                                            }}>
                                                <p>Colombia</p>
                                            </div>
                                        </>
                                        :
                                        ''
                                }
                            </div>
                            <div>
                                <Location size="32" color="#004274" />
                            </div>
                        </div>
                    </div>
                    <div className='tourHeaderSearch_buttonSearch' onClick={() => findTours(place)}>
                        <SearchNormal1 size="32" color="#004274" />
                    </div>
                </div>
                {
                    error &&
                    <div className='error-send-tours'>
                        <p>Debes seleccionar un destino</p>
                    </div>
                }
            </div>
        </div>
    )
}

export default TourHeaderSearch